import ls from '../../utils/localStorage.js';
import { getWin,getArchive } from '../../api/api';

const state = {
    win: ''
}

const mutations = {
    UPDATE_WIN(state,payload) {
        state.win = JSON.parse(payload);
    }
}

const getters = {

}

const actions = {

    // 赢通TOKEN生成
    requestWin(store,item) {
        getWin().then( data => {
            store.commit('UPDATE_WIN',JSON.stringify(data));
        }).catch(error => {

        })
    },

    // 1.04 提交线索信息
    requestArchive(store,item) {
      getArchive(item.data).then( data => {
        item.fromToast.clear();
        item.thit.loan = {
          name:'',
          phone:'',
          card:'',
          sms:''
        }
        
        console.log(data);
        
        item.thit.$toast.fail({
          duration: 1000,
          message: "提交成功！客服来电注意接听，谢谢！"
        });
      }).catch(error => {

      });
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}
